import { toaster } from 'baseui/toast';
import { ReactNode } from 'react';

interface Props {
  message: ReactNode;
  autoHideDuration?: number; // in miliseconds
  closeable?: boolean;
}

const notification = {
  success: ({ message, ...rest }: Props) =>
    toaster.positive(<>{message}</>, {
      autoHideDuration: 4000,
      closeable: true,
      ...rest,
    }),
  info: ({ message, ...rest }: Props) =>
    toaster.info(<>{message}</>, {
      autoHideDuration: 4000,
      closeable: true,
      ...rest,
    }),
  error: ({ message, ...rest }: Props) =>
    toaster.negative(<>{message}</>, {
      autoHideDuration: 4000,
      closeable: true,
      ...rest,
    }),
  warning: ({ message, ...rest }: Props) =>
    toaster.warning(<>{message}</>, {
      autoHideDuration: 4000,
      closeable: true,
      ...rest,
    }),
};

export default notification;
